// extracted by mini-css-extract-plugin
export default {"departments":"iG-z","departmentHeading":"jG-z","departmentSection":"kG-z","departmentName":"lG-z","departmentLink":"mG-z","expandIcon":"nG-z"};